"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layout = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var Notification_1 = require("./pages/Notification");
var core_1 = require("@athena-portal/core");
var services_1 = require("@falcon/services");
var VersionDisplay_1 = require("./pages/VersionDisplay");
var react_router_dom_1 = require("react-router-dom");
require("./helpers/load-monaco-editor");
var Layout = /** @class */ (function (_super) {
    __extends(Layout, _super);
    function Layout(props) {
        var _this = _super.call(this, props) || this;
        _this.renderHeader = function () {
            var clickLogout = function () {
                var redirectUrl = window.location.origin;
                _this.applicationGuard.logout({ redirectUri: redirectUrl });
            };
            return ((0, jsx_runtime_1.jsx)("div", { className: "journey-header common align-items-center", children: (0, jsx_runtime_1.jsxs)("div", { className: "journey-header-background container align-items-center pt-3 pb-3", children: [(0, jsx_runtime_1.jsx)("img", { className: "flow-logo", src: "/".concat(services_1.resourcesHelper.THEME, "/img/brand-logo.png"), alt: "".concat(services_1.resourcesHelper.THEME, " logo") }), (0, jsx_runtime_1.jsx)("div", { className: "spacer" }), (0, jsx_runtime_1.jsxs)("div", { className: "menu", children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/", children: "Search customer" }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/advancedSearch", children: "Advanced customer search" }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/interactionSearch", children: "Search interaction" }), _this.userHasRole(["Administrator"]) &&
                                    (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/calculateInteraction", children: "Calculate interaction" }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/transactionSearch", children: "Search transaction" }), _this.userHasRole(["Administrator", "Pricing"]) &&
                                    (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/decompressData", children: "Decompress raw data" })] }), (0, jsx_runtime_1.jsx)("button", { type: "button", className: "sign-out", onClick: clickLogout, "aria-label": "Sign out", children: (0, jsx_runtime_1.jsx)("img", { className: "sign-out-icon", src: "/img/power-off-white.png", alt: "" }) })] }) }));
        };
        _this.userHasRole = function (roles) {
            var user = _this.applicationGuard.getUser();
            if (user === null || !user || !user.roles) {
                return false;
            }
            return roles.some(function (role) { return user.roles.indexOf(role) > -1; });
        };
        _this.state = {
            showNotification: false,
            notificationMessage: ""
        };
        _this.hideNotification = _this.hideNotification.bind(_this);
        return _this;
    }
    Layout.prototype.componentDidMount = function () {
        var _this = this;
        this.notificationService.getFeed().subscribe(function (note) {
            if (note && _this.state.notificationMessage.indexOf(note.message) === -1) {
                note && _this.setState({
                    showNotification: true,
                    notificationMessage: "".concat(_this.state.notificationMessage, "\n").concat(note.message)
                });
            }
        });
    };
    Layout.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)("div", { className: "container-fluid", children: [this.renderHeader(), (0, jsx_runtime_1.jsx)("div", { className: "container pt-3 pb-3", children: (0, jsx_runtime_1.jsx)(components_1.Body, {}) })] }) }) }), (0, jsx_runtime_1.jsx)("footer", { className: "footer-position", children: (0, jsx_runtime_1.jsx)(components_1.Section, { id: "footer" }) }), (0, jsx_runtime_1.jsx)(VersionDisplay_1.VersionDisplay, {}), (0, jsx_runtime_1.jsx)(Notification_1.default, { show: this.state.showNotification, hide: this.hideNotification, title: "Error!", message: this.state.notificationMessage })] }));
    };
    Layout.prototype.hideNotification = function () {
        this.setState({
            showNotification: false,
            notificationMessage: ""
        });
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.NotificationService),
        __metadata("design:type", Object)
    ], Layout.prototype, "notificationService", void 0);
    __decorate([
        (0, core_1.lazyInject)(core_1.TypeDefs.ApplicationGuard),
        __metadata("design:type", Object)
    ], Layout.prototype, "applicationGuard", void 0);
    return Layout;
}(React.Component));
exports.Layout = Layout;
//# sourceMappingURL=Layout.js.map